var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"bg":"b"}},[_c('p',{staticClass:"about-slogan text-sm"},[_vm._v(" "+_vm._s(_vm.dic.brand)+" - "+_vm._s(_vm.dic.aboutSection.subTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }